import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { LicensePolicyForm } from '../../../components/license-policy-form'

function AngularLicensePolicyForm(props) {
  return <LicensePolicyForm {...props} />
}

export const reactLicensePolicyForm = createNgReactBridgeDirective(
  'reactLicensePolicyForm',
  [],
  AngularLicensePolicyForm,
  ['values', 'items', 'onUpdate']
)
